import Immutable from 'seamless-immutable';

export const oneItemStateChange = (state, key, found, notFound) => {
  for (let i = 0; i < state.questions.length; ++i) {
    const question = state.questions[i];
    if (question.key === key) {
      return Immutable.updateIn(state, ['questions', i], found);
    }
    for (let j = 0; j < question.answers.length; ++j) {
      const answer = question.answers[j];
      if (answer.key === key) {
        return Immutable.updateIn(state, ['questions', i, 'answers', j], found);
      }
    }
  }
  return notFound ? notFound() : state;
};
